<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>业务办理</a-breadcrumb-item>
				<a-breadcrumb-item>电梯卡管理</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="addVisible = true" type="primary">办卡</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiCardQueryList('page')">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="条件查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">卡名称：</div>
						<a-input v-model="query.cardName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">卡号：</div>
						<a-input-search v-model="query.cardNo" style="width: 100%;" placeholder="请出入卡号" enter-button="读卡" @search="cardRead('query')"/>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">卡类型：</div>
						<a-select v-model="query.cardType">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option :value="2">用户卡</a-select-option>
							<a-select-option :value="3">物业卡</a-select-option>
							<a-select-option :value="4">楼层测试卡</a-select-option>
							<a-select-option :value="5">开关卡</a-select-option>
						</a-select>
					</div>
				</div>
				<div class="qinang-search-row qinang-margin-top-12">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">有效时间：</div>
						<a-select v-model="query.expirationDate">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option :value="31">一个月内到期</a-select-option>
							<a-select-option :value="180">六个月内到期</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">状态：</div>
						<a-select v-model="query.cardState">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option :value="3">启用</a-select-option>
							<a-select-option :value="2">禁用</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
					</div>
		
				</div>
				<div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
					<a-button type="primary" icon="search" @click="apiCardQueryList('query')">查询</a-button>
					<a-button icon="redo" @click="resetChange" style="margin-left: 14px;">重置</a-button>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="cardId" :loading="tableLoading" :pagination="false">
				<span slot="cardName" slot-scope="cardName">
					<a-button type="link" @click="edit(cardName, 2)" >{{cardName.cardName}}</a-button>
				</span>
				<span slot="cardType" slot-scope="cardType">
					<span v-if="cardType == 2">用户卡</span>
					<span v-if="cardType == 3">物业卡</span>
					<span v-if="cardType == 4">楼层测试卡</span>
					<span v-if="cardType == 5">开关卡</span>
				</span>
				<span slot="cardState" slot-scope="cardState">
					<a-tag v-if="cardState == 3" color="green">启用</a-tag>
					<a-tag v-if="cardState == 2" color="red">禁用</a-tag>
				</span>
				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" @click="swipeChange(tableAction)">刷卡记录</a-button>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal class="qa-modal" title="添加" width="100%" :visible="addVisible"  @cancel="addVisible = false" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<div class="qa-table-item-2">
						<a-form-model-item label="卡名称" has-feedback prop="cardName">
							<a-input v-model="addForm.cardName"/>
						</a-form-model-item>
						<a-form-model-item label="是否读卡" has-feedback prop="isRead">
							<a-radio-group name="isRead" v-model="addForm.isRead">
								<a-radio :value="3">读卡</a-radio>
								<a-radio :value="2">手工录入</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3" v-if="addForm.isRead == 3">
						<a-form-model-item label="卡号" has-feedback >
							<a-input-search v-model="addForm.cardNo" enter-button="读卡" @search="cardRead('add')"/>
						</a-form-model-item>
						<a-form-model-item ></a-form-model-item>
						<a-form-model-item ></a-form-model-item>
					</div>
					<div class="qa-table-item-1" v-if="addForm.isRead == 2">
						<a-form-model-item label="卡号" has-feedback>
							<a-textarea placeholder="在这里批量输入卡号,多张卡用','隔开" :rows="2" v-model="addForm.cardNos" @change="cardNosChange('add')" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1" v-if="addForm.isRead == 2">
						<a-form-model-item label="已填卡号" has-feedback>
							<a-tag color="cyan" v-for="(item, index) in cardNosList" :key="index">{{item}}</a-tag>
						</a-form-model-item>
					</div>
					
					<div class="qa-table-item-3">
						<a-form-model-item label="卡类型" has-feedback prop="cardType">
							<a-select v-model="addForm.cardType">
							  <a-select-option :value="2">用户卡</a-select-option>
							  <a-select-option :value="3">物业卡</a-select-option>
							  <a-select-option :value="4">楼层测试卡</a-select-option>
							  <a-select-option :value="5">开关卡</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item >
							<a-tag color="orange" v-if="addForm.cardType == 2">用户卡：自定义楼层选择</a-tag>
							<a-tag color="orange" v-if="addForm.cardType == 3">物业卡：不限制楼层，所有楼层都可使用</a-tag>
							<a-tag color="orange" v-if="addForm.cardType == 4">楼层测试卡：测试每层按钮是否有故障</a-tag>
							<a-tag color="orange" v-if="addForm.cardType == 5">开关卡：当设备离线时，设备是否需要刷卡</a-tag>
						</a-form-model-item>
						<a-form-model-item ></a-form-model-item>
					</div>
					<div class="qa-table-item-2" v-if="addForm.cardType == 2">
						<a-form-model-item label="楼层选择" has-feedback>
							<a-tree v-model="addForm.cardStorey" checkable :tree-data="elevatorList"/>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3" v-if="addForm.cardType == 2 || addForm.cardType == 3">
						<a-form-model-item label="生效日期" has-feedback prop="startTime">
							<a-date-picker v-model="addForm.startTime" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<a-form-model-item label="失效日期" has-feedback prop="endTime">
							<a-date-picker v-model="addForm.endTime" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<a-form-model-item ></a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="是否启用" has-feedback prop="cardState">
							<a-radio-group name="cardState" v-model="addForm.cardState">
								<a-radio :value="3">是</a-radio>
								<a-radio :value="2">否</a-radio>
							</a-radio-group>
						</a-form-model-item>
						<a-form-model-item ></a-form-model-item>
						<a-form-model-item ></a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="备注" has-feedback>
							<a-textarea placeholder="在这里输入备注" :rows="2" v-model="addForm.remarks" />
						</a-form-model-item>
					</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="addVisible = false">返回</a-button>
						<a-button type="primary" @click="addHandleOk">保存</a-button>
					</div>
				</a-form-model>
			</div>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal class="qa-modal" title="修改" width="100%" :visible="editVisible"  @cancel="editVisible = false" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<div class="qa-table-item-2">
						<a-form-model-item label="卡名称" has-feedback prop="cardName">
							<a-input v-model="editForm.cardName" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="卡号" has-feedback >
							<a-input-search v-model="editForm.cardNo" enter-button="读卡" @search="cardRead('edit')"/>
						</a-form-model-item>
						<a-form-model-item ></a-form-model-item>
						<a-form-model-item ></a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="卡类型" has-feedback prop="cardType">
							<a-select v-model="editForm.cardType">
							  <a-select-option :value="2">用户卡</a-select-option>
							  <a-select-option :value="3">物业卡</a-select-option>
							  <a-select-option :value="4">楼层测试卡</a-select-option>
							  <a-select-option :value="5">开关卡</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item >
							<a-tag color="orange" v-if="editForm.cardType == 2">用户卡：自定义楼层选择</a-tag>
							<a-tag color="orange" v-if="editForm.cardType == 3">物业卡：不限制楼层，所有楼层都可使用</a-tag>
							<a-tag color="orange" v-if="editForm.cardType == 4">楼层测试卡：测试每层按钮是否有故障</a-tag>
							<a-tag color="orange" v-if="editForm.cardType == 5">开关卡：当设备离线时，设备是否需要刷卡</a-tag>
						</a-form-model-item>
						<a-form-model-item ></a-form-model-item>
					</div>
					<div class="qa-table-item-2" v-if="editForm.cardType == 2">
						<a-form-model-item label="楼层选择" has-feedback>
							<a-tree v-model="editForm.cardStorey" checkable :tree-data="elevatorList"/>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3" v-if="editForm.cardType == 2 || editForm.cardType == 3">
						<a-form-model-item label="生效日期" has-feedback prop="startTime" >
							<a-date-picker v-model="editForm.startTime" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<a-form-model-item label="失效日期" has-feedback prop="endTime">
							<a-date-picker v-model="editForm.endTime" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<a-form-model-item ></a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="是否启用" has-feedback prop="cardState">
							<a-radio-group name="cardState" v-model="editForm.cardState">
								<a-radio :value="3">是</a-radio>
								<a-radio :value="2">否</a-radio>
							</a-radio-group>
						</a-form-model-item>
						<a-form-model-item ></a-form-model-item>
						<a-form-model-item ></a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="备注" has-feedback>
							<a-textarea placeholder="在这里输入备注" :rows="2" v-model="editForm.remarks" />
						</a-form-model-item>
					</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="editVisible = false">返回</a-button>
						<a-button type="primary" @click="editHandleOk">保存</a-button>
					</div>
				</a-form-model>
			</div>
		</a-modal>
		
		<!-- 批量修改 -->
		<a-modal class="qa-modal" title="批量修改" width="100%" :visible="editVisibleBatch"  @cancel="editVisibleBatch = false" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<div class="qa-table-item-1">
						<a-form-model-item label="已选中卡" has-feedback prop="cardName">
							<a-tag color="cyan" v-for="(item, index) in editForm.cardList" :key="index">{{item.cardName}}</a-tag>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-2" v-if="editForm.cardType == 2">
						<a-form-model-item label="楼层选择" has-feedback>
							<a-tree v-model="editForm.cardStorey" checkable :tree-data="elevatorList"/>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3" v-if="editForm.cardType == 2 || editForm.cardType == 3">
						<a-form-model-item label="生效日期" has-feedback prop="startTime" >
							<a-date-picker v-model="editForm.startTime" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<a-form-model-item label="失效日期" has-feedback prop="endTime">
							<a-date-picker v-model="editForm.endTime" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<a-form-model-item ></a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="是否启用" has-feedback prop="cardState">
							<a-radio-group name="cardState" v-model="editForm.cardState">
								<a-radio :value="3">是</a-radio>
								<a-radio :value="2">否</a-radio>
							</a-radio-group>
						</a-form-model-item>
						<a-form-model-item ></a-form-model-item>
						<a-form-model-item ></a-form-model-item>
					</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="editVisibleBatch = false">返回</a-button>
						<a-button type="primary" @click="editHandleOk">保存</a-button>
					</div>
				</a-form-model>
			</div>
		</a-modal>
		
		<!-- 刷卡记录 -->
		<a-modal title="刷卡记录" width="80%" :visible="swipeVisible"  @cancel="swipeVisible = false" :footer="null" :maskClosable="false" :keyboard="false">
			
		</a-modal>
		
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					cardName: '',
					cardNo: '',
					cardType: 0,
					expirationDate: 0,
					cardState: 0,
				},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'cardId', key:'cardId', align:'center'},
					{ title:'卡名称', key:'cardName', align:'center', scopedSlots:{customRender:'cardName'}},
					{ title:'卡号', key:'cardNo', dataIndex:'cardNo', align:'center'},
					{ title:'卡类型', dataIndex:'cardType', key:'cardType', align:'center', scopedSlots:{customRender:'cardType'}},
					{ title:'生效日期', key:'startTime', dataIndex:'startTime', align:'center'},
					{ title:'失效日期', key:'endTime', dataIndex:'endTime', align:'center'},
					{ title:'状态', dataIndex:'cardState', key:'cardState', align:'center', scopedSlots:{customRender:'cardState'}},
					// {
					// 	title: '操作',
					// 	key: 'tableAction',
					// 	align: 'center',
					// 	scopedSlots: {
					// 		customRender: 'tableAction'
					// 	}
					// },
				],
				tableLoading: false,
				tableSelectedRows: [],
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				elevatorList: [],
				addForm: {
					cardName: '',
					cardNo: '',
					cardType: 2,
					cardStorey: [],
					startTime: moment(),
					endTime: moment(),
					cardState: 3,
					remarks: '',
					isRead: 3,
					cardNos: '',
				},
				cardNosList: [],
				addRules: {
					cardName: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
					cardType: [{ required: true, message: '请选择', trigger: 'blur' }],
					cardNo: [{ required: true, message: '卡号不能为空', trigger: 'blur' }],
					startTime: [{ required: true, message: '请选择', trigger: 'blur' }],
					endTime: [{ required: true, message: '请选择', trigger: 'blur' }],
					cardState: [{ required: true, message: '请选择', trigger: 'blur' }],
					isRead: [{ required: true, message: '请选择', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editVisibleBatch: false,
				editConfirmLoading: false,
				editForm: {
					cardList: [],//支持批量修改
					cardId: '',
					cardName: '',
					cardNo: '',
					oldCardNo: '',
					cardType: 2,
					oldCardType: 2,
					cardStorey: [],
					startTime: '',
					endTime: '',
					cardState: 3,
					remarks: '',
				},
				// 修改弹窗-end
				//读卡器相关
				cardReader: {
					port: null,
					reader: null,
					reading: false
				},
				swipeVisible: false,
				swipeConfirmLoading: false,
			};
		},
		methods: {
			//获取所有楼层信息
			async apiElevatorList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiElevatorList, this.query);
				if (res.code == 200) {
					let d = res.data
					let list = []
					for (let i=0; i<d.length; i++) {
						let elevatorStorey = d[i].elevatorStorey.split(",")
						let chi = []
						for (let ii=0; ii<elevatorStorey.length; ii++) {
							chi.push({title: elevatorStorey[ii], key: d[i].elevatorId + '&' + elevatorStorey[ii]})
						}
						list.push({title: d[i].elevatorName, key: d[i].elevatorId, children: chi})
					}
					this.elevatorList = list
				} else {
					this.$message.error(res.msg)
				}
			},
			//重置
			resetChange() {
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					cardName: '',
					cardNo: '',
					cardType: 0,
					expirationDate: 0,
					cardState: 0,
				}
			},
			//表格开始-搜索
			async apiCardQueryList(type) {
				if (type == 'query') {
					this.query.page = 1
				}
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCardQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiCardQueryList('page')
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiCardQueryList('page')
			},
			async apiCardAdd() {
				let startTime = this.addForm.startTime
				let	endTime = this.addForm.endTime
				let data = JSON.parse(JSON.stringify(this.addForm))
				data.startTime = this.addForm.startTime.format('YYYY-MM-DD')
				data.endTime = this.addForm.endTime.format('YYYY-MM-DD')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCardAdd, data);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiCardQueryList('query')
					this.addConfirmLoading = false
					this.addVisible = false
					this.addForm = {
						cardName: '',
						cardNo: '',
						cardType: 2,
						cardStorey: [],
						cardState: 3,
						remarks: '',
						isRead: 3,
						cardNos: '',
						startTime: '',
						endTime: ''
					}
					this.addForm.startTime = startTime
					this.addForm.endTime = endTime
					this.cardNosList = []
					
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			//添加按钮
			async addHandleOk() {
				if (this.addForm.cardName == '') {
					this.$error({
						title: '卡名称 不能为空'
					});
					return
				}
				if (this.addForm.isRead == 2) {
					if (this.addForm.cardNos == '') {
						this.$error({
							title: '卡号 不能为空'
						});
						return
					}
					if (this.addForm.cardType != 2) {
						this.$error({
							title: '只有“用户卡”支持手工录入'
						});
						return
					}
					this.$refs.addRuleForm.validate(valid => {
						if (valid) {
							this.apiCardAdd()
						} else {
						  return false;
						  this.addConfirmLoading = true
						}
					});
					return
				}
				if (this.addForm.cardNo == '') {
					this.$error({
						title: '卡号 不能为空'
					});
					return
				}
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCardList, this.addForm);
				if (res.code == 200) {
					if (res.data.length > 0) {
						this.$error({
							title: '卡号已存在'
						});
					} else {
						//需先读卡
						if(this.cardUtil.getPort() == null) {
							this.cardUtil.cardReaderIni()
						} else {
							await this.cardUtil.getCardId()
							var timer = setInterval(() =>{
								if(this.cardUtil.getReading() == false) {
									this.setPwd(2)
									clearInterval(timer)
								}
							}, 200)
						}
					}
				} else {
					this.$error({
						title: '系统错误'
					});
				}
		
			},
			setPwd(type) {
				let data = this.cardUtil.getSerialData()
				if(data == 'ee02230114dd') {
					this.$error({
						title: '读卡失败！未识别到有效卡'
					});
					return
				}
				let cardId = data.slice(8, 16)
				if (type == 2) {
					if (this.addForm.cardNo != cardId) {
						this.$error({
							title: '请先读卡后再保存'
						});
						return
					}
				}
				if (type == 3) {
					if (this.editForm.cardNo != cardId) {
						this.$error({
							title: '请先读卡后再保存'
						});
						return
					}
				}
				this.cardUtil.setPwd(cardId)
				var timer = setInterval(() =>{
					if(this.cardUtil.getReading() == false) {
						// this.setSq(type)
						this.setType(type)
						clearInterval(timer)
					}
				}, 200)
			},
			setSq(type) {
				let data = this.cardUtil.getSerialData()
				if(data != 'ee02240014dd') {
					this.$error({
						title: '卡密码错误，请初始化'
					});
					return
				}
				this.cardUtil.setSq(type)
				var timer = setInterval(() =>{
					if(this.cardUtil.getReading() == false) {
						this.setType(type)
						clearInterval(timer)
					}
				}, 200)
			},
			//设置卡类型
			setType(type) {
				let data = this.cardUtil.getSerialData()
				if(data != 'ee02260016dd' && data != 'ee02240014dd') {
					this.$error({
						title: '扇区修改错误'
					});
					return
				}
				if (type == 2) {
					this.cardUtil.setType(this.addForm.cardType)
					var timer = setInterval(() =>{
						if(this.cardUtil.getReading() == false) {
							this.addHandleEnd()
							clearInterval(timer)
						}
					}, 200)
				} else {
					this.cardUtil.setType(this.editForm.cardType)
					var timer = setInterval(() =>{
						if(this.cardUtil.getReading() == false) {
							this.addHandleEnd()
							clearInterval(timer)
						}
					}, 200)
				}
				
			},
			addHandleEnd() {
				let data = this.cardUtil.getSerialData()
				if(data != 'ee02280018dd') {
					this.$error({
						title: '写卡失败，请初始化'
					});
					return
				}
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiCardAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
			},
			editHandleEnd() {
				let data = this.cardUtil.getSerialData()
				if(data != 'ee02280018dd') {
					this.$error({
						title: '写卡失败，请初始化'
					});
					return
				}
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiCardEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
			},
			//楼层输入变化时()
			cardNosChange(type) {
				if (type == 'add') {
					this.cardNosList = this.addForm.cardNos.split(",")
				}
				
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item, type){
				if (type == 2) {
					//非批量更新
					let items = JSON.parse(JSON.stringify(item))
					items.startTime = this.moment(item.startTime)
					items.endTime = this.moment(item.endTime)
					items.cardStorey = JSON.parse(item.cardStorey)
					items.oldCardNo = items.cardNo
					items.oldCardType = items.cardType
					items.cardList = []
					this.editForm = items
					this.editVisible = true
				} else {
					//批量修改
					//暂时只支持用户卡批量修改
					if (item[0].cardType != 2) {
						this.$error({
							title: '只支持“用户卡”批量修改'
						});
						return
					}
					let items = JSON.parse(JSON.stringify(item[0]))
					items.startTime = this.moment(item[0].startTime)
					items.endTime = this.moment(item[0].endTime)
					items.cardStorey = JSON.parse(item[0].cardStorey)
					items.cardList = item
					this.editForm = items
					this.editVisibleBatch = true
				}
				
			},
			async apiCardEdit() {
				let data = JSON.parse(JSON.stringify(this.editForm))
				data.startTime = this.editForm.startTime.format('YYYY-MM-DD')
				data.endTime = this.editForm.endTime.format('YYYY-MM-DD')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCardEdit, data);
				if (res.code == 200) {
					this.$message.success(res.msg)
					
					this.apiCardQueryList('page')
					if (this.editForm.cardList.length > 0) {
						this.editVisibleBatch = false
					} else {
						this.editVisible = false
					}
					this.editConfirmLoading = false
					
					this.$refs.editRuleForm.resetFields();
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			async editHandleOk() {
				if (this.editForm.cardList.length > 0) {
					//批量更新
					this.$refs.editRuleForm.validate(valid => {
						if (valid) {
							this.apiCardEdit()
						} else {
						  return false;
						  this.editConfirmLoading = true
						}
					});
					return
				}
				
				if (this.editForm.cardName == '') {
					this.$error({
						title: '卡名称 不能为空'
					});
					return
				}
				if (this.editForm.cardNo == '') {
					this.$error({
						title: '卡号 不能为空'
					});
					return
				}
				
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCardList, this.editForm);
				if (res.code == 200) {
					if (res.data.length > 0) {
						if (res.data[0].cardId != this.editForm.cardId) {
							this.$error({
								title: '卡号已存在'
							});
							return
						}
					}
					//默认不需要重新读卡
					let needReadCard = false
					//需先读卡
					if (this.editForm.cardNo != this.editForm.oldCardNo) needReadCard = true
					if (this.editForm.cardType != this.editForm.oldCardType) {
						if (this.editForm.cardType == 4 || this.editForm.cardType == 5) {
							needReadCard = true
						}
					}
					
					if (needReadCard == false) {
						this.$refs.editRuleForm.validate(valid => {
							if (valid) {
								this.apiCardEdit()
							} else {
							  return false;
							  this.editConfirmLoading = true
							}
						});
					} else {
						//需先读卡
						if(this.cardUtil.getPort() == null) {
							this.cardUtil.cardReaderIni()
						} else {
							await this.cardUtil.getCardId()
							var timer = setInterval(() =>{
								if(this.cardUtil.getReading() == false) {
									this.setPwd(3)
									clearInterval(timer)
								}
							}, 200)
						}
					}
				} else {
					this.$error({
						title: '系统错误'
					});
				}
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				if(this.tableSelectedRows.length ==0) {
					this.$message.error("请选择要删除的数据")
					return
				}
				if(this.tableSelectedRows.length > 1) {
					this.$message.error("不支持批量删除，请选择一条数据")
					return
				}
				let that = this
				if(this.tableSelectedRows[0].cardId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows[0].cardName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiCardDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiCardDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCardDel, {cardId: this.tableSelectedRows[0].cardId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiCardQueryList('page')
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				//判断是否为批量修改
				let count = this.tableSelectedRows.length
				if (count == 0) {
					this.$message.warning('请选择要修改的数据')
					return
				}
				if (count == 1) {
					this.edit(this.tableSelectedRows[0], 2)
				} else {
					//批量修改
					this.edit(this.tableSelectedRows, 3)
				}
				// if(this.tableSelectedRows.cardId > 0) {
				// 	this.edit(this.tableSelectedRows)
				// }else{
				// 	this.$message.warning('请选择要修改的数据');
				// }
			},
		
			//初始化卡
			// async 
			
			//点击按钮读卡
			async cardRead(from) {
				if(this.cardUtil.getPort() == null) {
					this.cardUtil.cardReaderIni()
				} else {
					
					// const {
					// 	data: res
					// } = await this.cardUtil.getCardId()
					await this.cardUtil.getCardId()
					var timer = setInterval(() =>{
						if(this.cardUtil.getReading() == false) {
							this.readCardFinish(2, from, this.cardUtil.getSerialData())
							clearInterval(timer)
						}
					}, 200)
				}
			},
			readCardFinish(type, from, data) {
				switch(type) {
					//读卡指令
					case 2:
						if(data == 'ee02230114dd') {
							this.$error({
								title: '读卡失败！未识别到有效卡'
							});
						}else{
							if(from == 'add') {
								this.addForm.cardNo = data.slice(8, 16)
							}
							if(from == 'edit') {
								this.editForm.cardNo = data.slice(8, 16)
							}
							if(from == 'query') {
								this.query.cardNo = data.slice(8, 16)
							}
							this.$message.success('读卡成功');
						}
						break;
					default:
						break;
				}
			},
			swipeChange(item) {
				this.swipeVisible = true
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'checkbox',
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiCardQueryList('query')
			this.apiElevatorList()
		}
	};
</script>

<style scoped>
	/deep/ .ant-tree-child-tree{
		display: flex !important;
		/* align-items: center; */
		flex-wrap: wrap;
		.ant-tree-treenode-switcher-open{
			width: 60px;
		}
		.ant-tree-treenode-switcher-close{
			width: 60px;
		}
	}
	/deep/ .ant-tree-child-tree > li:first-child {
		padding-top: 4px !important;
	}
</style>
